import EmbeddableAudioPlayer from './EmbeddableAudioPlayer';

export default EmbeddableAudioPlayer;
